import React from 'react';
import HeaderView from "./view";

const Header = () => {
    return (
        <div><HeaderView /></div>
    )
}

export default  Header;